// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const selectAllRegistrationStatuses = () => ({
    type: actions.SELECT_ALL_REGISTRATIONS_REVIEW_REGISTRATIONS_STATUSES
});

export const selectRegistrationStatus = (status, isSelected) => ({
    isSelected,
    status,
    type: actions.SELECT_REGISTRATIONS_REVIEW_REGISTRATION_STATUS
});



// WEBPACK FOOTER //
// ./src/reports/registrations-review/action-creators/select-registration-status.js